import { BriefingFormModel } from "pages/BriefingForm/interfaces";
import { phoneRegExp } from "validation";
import * as yup from "yup";

export const TRU_SKIN = "Tru_Skin";
export const TRU_SKIN_IDS = ["Tru_Skin_460x1080", "Tru_Skin_1000x250", "Tru_Skin_1000x100", "Tru_Skin_1920x1080"];
export const MAX_BESPOKE_LENGTH = 5;
export const MAX_BUNDLE_LENGTH = 5;

export const briefingFormDefaultValues: BriefingFormModel = {
    salesRep: {
        name: "",
        email: "",
        phone: "",
    },
    adSize: {
        type: "BUNDLE",
        sizes: [],
    },
    adDesign: {
        type: "STATIC",
        complexity: "EASY",
    },
    digitalBrief: {
        ioNumber: "",
        assets: [
            {
                fileName: null,
                id: null,
                copyText: "",
            },
            {
                fileName: null,
                id: null,
                copyText: "",
            },
            {
                fileName: null,
                id: null,
                copyText: "",
            },
        ],
        callToAction: "",
        landingURL: "",
        specialInstructions: "",
    },
};

export const briefingFormUpdateSchema = yup.object().shape({
    salesRep: yup.object().shape({
        name: yup.string().required("Name is required"),
        email: yup.string().email("Must be a valid email").required("Email is required"),
        phone: yup.string().matches(phoneRegExp, "Phone number is not valid").notRequired(),
    }),
    adSize: yup.object().shape({
        type: yup.string().oneOf(["BUNDLE", "BESPOKE"]).required("Ad size type is required"),
        sizes: yup
            .array()
            .when(["type"], {
                is: (type) => type === "BUNDLE",
                then: yup
                    .array()
                    .min(1, "At least 1 ad size must be selected")
                    .max(MAX_BUNDLE_LENGTH, "Maximum 5 ad sizes can be selected")
                    .of(yup.string()),
            })
            .when(["type"], {
                is: (type) => type === "BESPOKE",
                then: yup
                    .array()
                    .min(1, "At least 1 ad size must be selected")
                    .max(MAX_BESPOKE_LENGTH, "Maximum 5 ad sizes can be selected") // there are 5 fields in BESPOKE but one field includes 4 items
                    .of(yup.string()),
            }),
    }),
    adDesign: yup.object().shape({
        type: yup.string().oneOf(["STATIC", "ANIMATED"]).required("Ad design type must be selected"),
        complexity: yup
            .string()
            .oneOf(["EASY", "MODERATE", "DIFFICULT"])
            .required("Ad design complexity must be selected"),
    }),
    digitalBrief: yup.object().shape({
        ioNumber: yup.string(),
        callToAction: yup.string().required("Call to action is required"),
        landingURL: yup.string().required("Landing URL is required"),
        specialInstructions: yup.string(),
        assets: yup
            .array()
            .min(1)
            .of(
                yup.object().shape({
                    id: yup.number(),
                    copyText: yup.string(),
                })
            ),
    }),
});
